
import { observable, action } from 'mobx';
import {Face,Star} from '@material-ui/icons'
import profileImg from './static/images/profile2.jpg'
class MyState {
    @observable navigatorData = [{
                            path:'/',
                            value:'个人概览',
                        },{
                            path:'/projectIntroduce',
                            value:'个人项目',
                        },{
                            path:'/skillintro',
                            value:'技能简介',
                        },{
                            path:'/articles',
                            value:'博客文章',
                        },{
                            path:'/news',
                            value:'最新动态',
                        },{
                            path:'/others',
                            value:'杂事',
                        },{
                            path:'/error',
                            value:' ',
                        }];
    @observable defaultPathIndex=0
    //下面是project数据
    @observable selfIntoinfo={
        title:'个人简介',
        paragraphs:[
            {
                name:'Github',
                type:'profile',
                Picon:null,
                description:'https://github.com/WEN-JY/',
                level:null,
            },
            {
                name:'SegmentFault',
                type:'profile',
                Picon:null,
                description:'https://segmentfault.com/u/lanlandejishuzhai',
                level:null,
            },
            {
                name:'Blog',
                type:'profile',
                Picon:null,
                description:'https://wen-jy.github.io',
                level:null,
            },
            {
                name:'2012.9-2016.6',
                type:'profile',
                Picon:null,
                description:'北京交通大学 机械与电子控制工程学院 能源与动力工程专业;',
                level:null,
            },
            {
                name:'2016.8-至今',
                type:'profile',
                Picon:null,
                description:'就职于上海铁路集团南京动车段,主要从事node全栈开发相关工作;',
                level:null,
            },
            {
                name:'2017.5',
                type:'profile',
                Picon:null,
                description:'获得南京动车段“5.4优秀团员”称号;',
                level:null,
            },
            {
                name:'2017.7',
                type:'profile',
                Picon:null,
                description:'获得武汉高铁职业技能训练段优秀班干部奖项;',
                level:null,
            },
            {
                name:'2018.1',
                type:'profile',
                Picon:null,
                description:'获得南京动车段2017年度段四十佳“优秀新人”称号;',
                level:null,
            },{
                name:'自我总结',
                type:'profile',
                Picon:null,
                description:`对web开发技术保持高度的敏感性和关注度，熟悉产品开发流程，
                有很强的产品规划、需求分析、交互设计能力，能独立承担WEB
                目的开发工作，善于沟通，贴近用户，有多个独立完成的中小项目经验;热爱音乐，自学吉他弹唱，常见流行歌曲拿着谱子就能弹，青春阳光，
                待人随和的技术男。曾多次参与单位举办的文艺活动并获得奖项;`,
                level:null,
            }
        ],
        MyIcon:Face,
        profileImg
    }
    @observable skillIntoinfo={
        title:'技能简介',
        paragraphs:[
            {
                name:'CET',
                type:'languagae',
                Picon:null,
                description:'CET六级，熟练的英语听说读写能力，经常科学上网以于都相关文档说明，在stackoverflow上提出问题，解决问题',
                level:80,
            },
            {
                name:'javascript',
                type:'front',
                Picon:null,
                description:'熟练使用javascript进行前端交互功能开发，进行nodejs服务器端开发，熟练掌握ES6语法，了解EventLoop执行机制',
                level:88,
            },
            {
                name:'html5',
                type:'front',
                Picon:null,
                description:'熟练使用html5的新特性---websocket,localstorage,sessionStorage,语义化标签,canvas绘图等',
                level:90,
            },
            {
                name:'css3',
                type:'front',
                Picon:null,
                description:'熟练使用css3的相关属性，进行UI设计',
                level:70,
            },
            {
                name:'jquery',
                type:'front',
                Picon:null,
                description:'了解jquery设计原理，使用过jquery进行前端开发，掌握成都一般',
                level:60,
            },
            {
                name:'VUE',
                type:'front',
                Picon:null,
                description:'熟练使用Vue进行前端组件化开发，掌握Vue数据绑定原理，掌握Vue组件通信常用方法',
                level:90,
            },
            {
                name:'REACT',
                type:'front',
                Picon:null,
                description:'熟练使用REACT进行前端组件化开发，掌握REACT数据绑定原理，掌握REACT组件通信，状态管理，事件处理，生命周期的相关知识',
                level:80,
            },
            {
                name:'Redux',
                type:'front',
                Picon:null,
                description:'熟练使用Redux进行react项目的state管理',
                level:80,
            },
            {
                name:'mobx',
                type:'front',
                Picon:null,
                description:'熟练使用mobx进行react项目的state管理',
                level:85,
            },
            {
                name:'Nodejs',
                type:'server',
                Picon:null,
                description:'熟练使用node常用模块进行服务端应用搭建，数据处理，文件存储，响应请求及权限验证等相关功能',
                level:89,
            },
            {
                name:'PHP',
                type:'server',
                Picon:null,
                description:'能够使用php进行服务端应用搭建，数据处理，文件存储，响应请求及权限验证等相关功能',
                level:80,
            },
            {
                name:'Express',
                type:'server',
                Picon:null,
                description:'熟练使用Express进行服务端应用搭建',
                level:80,
            },
            {
                name:'koa2',
                type:'server',
                Picon:null,
                description:'熟练使用',
                level:70,
            },
            {
                name:'BootStrap',
                type:'fron-ui',
                Picon:null,
                description:'熟练使用',
                level:80,
            },
            {
                name:'ElementUI',
                type:'fron-ui',
                Picon:null,
                description:'熟练使用',
                level:90,
            },
            {
                name:'Ant-Design',
                type:'fron-ui',
                Picon:null,
                description:'熟练使用',
                level:75,
            },
            {
                name:'Material-UI',
                type:'fron-ui',
                Picon:null,
                description:'熟练使用',
                level:75,
            },
            {
                name:'Mysql',
                type:'server-db',
                Picon:null,
                description:'熟练使用，但不涉及高并发及性能优化',
                level:80,
            },
            {
                name:'MongoDB',
                type:'server-db',
                Picon:null,
                description:'熟练使用，但不涉及高并发及性能优化',
                level:80,
            },
            {
                name:'前端性能优化',
                type:'others',
                Picon:null,
                description:'常见的前端性能优化手段进行性能瓶颈的查看，优化',
                level:84,
            },
            {
                name:'Photoshop',
                type:'design',
                Picon:null,
                description:'熟练使用',
                level:85,
            },
            {
                name:'AfterEffects',
                type:'design',
                Picon:null,
                description:'熟练使用',
                level:85,
            },
            {
                name:'Audition',
                type:'design',
                Picon:null,
                description:'熟练使用',
                level:85,
            },
            {
                name:'Premiere',
                type:'design',
                Picon:null,
                description:'熟练使用',
                level:80,
            },
            {
                name:'Guitar',
                type:'hobby',
                Picon:null,
                description:'熟练使用',
                level:93,
            },
        ],
        MyIcon:Star
    }
    @observable projectsInfo=[
        {
            projectName:'督办系统、乘务工时系统、人员信息管理系统',
            startTime:'2016.08',
            endTime:'2016.12',
            department:'上海铁路局南京动车段青年创新工作室',
            role:'项目开发组长',
            projectDetails:[`带领自己的团队，根据
            单位的办公需求，完成督办系统、乘务工时系统、
            人员信息管理系统的前（VUE）后（PHP）端开发，同时学习了JS图
            表插件Echarts等。`
            ,`项目中大量使用组件化开发思想，提高了代码的复用率，
            方便了后期的维护。`,`督办系统具有登陆，权限验证、
            项目下发、完成情况回填、月度统计，年度统计的功能，并分析各部门完成对比图表。`,
        `乘务工时系统，具有交路工时系统具有excel上传数据分析、统计汇总，
        排序，超出额定指标调用邮件系统API提醒的功能`,`人员信息系统，具有权限验证，信息录入展示，打印图表，
        对职工各种比赛比武成绩进行可视化展示的功能，同时，具有证书
        管理，成绩动态曲线查看，职工通报等功能模块。`],
            projectLinks:''
        },
        {
            projectName:'自管工程管理系统',
            startTime:'2017.01',
            endTime:'2017.09',
            department:'上海铁路局南京动车段党委办公室',
            role:'全栈工程师',
            projectDetails:[`项目中node作为服务器端，进行组件化前后端、使用NODE+VUE独立完成自管工程管理系统`
            ,`服务器使用Express框架，数据库使用Mysql。`,`前端使用Element UI组件库。`,
        `系统具有权限验证、文书归档、新闻动态、合同流转、审批功能`,`调用南京动车段电子公文接口进行邮件通知`,`从
        项目立项，招标，公示，中标结果审核，资金支付等方便对资管工程项目进行全方位的管理审核。`],
            projectLinks:''
        },
        {
            projectName:'宿舍信息管理系统',
            startTime:'2017.11',
            endTime:'2017.12',
            department:'上海铁路局南京动车段行政办公室',
            role:'全栈工程师',
            projectDetails:[`项目中Node Express作为服务器，使用VUE框架及webpack进行前端开发、独立完成宿舍信息管理系统`
            ,`	服务器使用express框架，数据库使用Mysql，MongoDB。`,
        `前端使用ElementUI组件库。`,`服务器端使用了exceljs模块处理表格数据，前端使用了大量canvas绘制报表内容。`,`
        系统具有权限验证，表格上传、数据分析、信息变更、多表复杂表头导出、Canvas绘制图像、申请审批流转等功能。`],
            projectLinks:''
        },
        {
            projectName:'工时测算系统',
            startTime:'2018.01',
            endTime:'2018.02',
            department:'上海铁路局南京动车段劳动人事科',
            role:'全栈工程师',
            projectDetails:[`项目中node express作为服务器，使用VUE框架及webpack进行前端开发、独立完成工时测算系统`
            ,`服务器使用express框架，数据库使用MongoDB。`,
        `前端使用ElementUI组件库。`,`
        服务器端使用了exceljs模块处理表格数据`,`
        使用Redis数据库存储session。`,`使用PM2进行进程守护，同时实现服务器负载均衡。`],
            projectLinks:''
        },
        {
            projectName:'实时信息共享程序',
            startTime:'2018.01',
            endTime:'2018.02',
            department:'上海铁路局南京动车段劳动人事科',
            role:'全栈工程师',
            projectDetails:[`使用Koa2+React构建单页应用；`
            ,`使用React-router对路由进行操作管理；`,
        `使用Redux进行状态管理；`,`
        使用Antd界面库；`,`
        使用websocket（socket.io）进行即时通讯；`,`使用electron进行了打包，成为独立的桌面应用程序实时信息共享程序；`],
            projectLinks:''
        }
    ]
    @observable musics=[
        {
            musicName:'六月的雨',
            src:'../static/music/胡歌 - 六月的雨《仙剑奇侠传》电视原声.mp3',//这里的../相对于musiccard
            artist:'胡歌',
            imgsrc:'music.jpg'
        }
    ]
    @observable musicsPlayIndex=0;
    @observable snackbarState = {
        open: false,
        vertical: null,
        horizontal: null,
      };
  
    @action ToggleSnackState(){
        if(this.snackbarState.open){
            console.log('excuted','hidden')
            this.snackbarState={
                open: false,
                vertical: 'top',
                horizontal: 'center',
              };
        }else{
            console.log('excuted show')
            this.snackbarState={
                open: true,
                vertical: 'top',
                horizontal: 'center',
              };
        }
    }
  }
  
  const newState = new MyState();
export default newState;


// WEBPACK FOOTER //
// ./src/state.js